import api from './client';

/**
 * Phase 38A.4 · Universal session API — Waiting Room + realtime lifecycle.
 * See backend/routes/sessions.py for the endpoint contracts.
 */

export const getWaitingState = async (sessionId) => {
  const res = await api.get(`/sessions/${sessionId}/waiting-state`);
  return res.data;
};

export const postSessionHeartbeat = async (sessionId) => {
  const res = await api.post(`/sessions/${sessionId}/heartbeat`);
  return res.data;
};

export const postCreatorConsent = async (sessionId) => {
  const res = await api.post(`/sessions/${sessionId}/creator-consent`);
  return res.data;
};

export const joinSession = async (sessionId) => {
  const res = await api.post(`/sessions/${sessionId}/join`);
  return res.data;
};

export const leaveSession = async (sessionId) => {
  const res = await api.post(`/sessions/${sessionId}/leave`);
  return res.data;
};
